import React from "react";
import { Box, Grid } from "@mui/material";
import { observer } from "mobx-react-lite";
import user from "../../../Mobx/User";

import ImageSection from "./NewImageSection";
import SentenceSection from "./NewSentenceSection";
import DefinitionSection from "./NewDefinitionSection";
import StorySection from "./NewStorySection";
import DistractingForTrnsSection from "./NewDistractingForTrnsSection";
import DistractingForOriginalSection from "./NewDistractingForOriginalSection";
import OppositesSection from "./NewOppositesSection";
import SynonymsSection from "./NewSynonymsSection";
import SentencesWithMissingSection from "./NewSentencesWithMissingSection";
import SentencesWithLastMissingSection from "./NewSentencesWithLastMissingSection";
import DistractingForDefinitionInEngSection from "./NewDistractingForDefinitionInEngSection";
import DistractingForDefinitionInHebSection from "./NewDistractingForDefinitionInHebSection";
import DistractingForWordFamiliesSection from "./NewDistractingForWordFamiliesSection";
import NewTrnsArSection from "./NewTrnsArSection";
import NewTrnsRuSection from "./NewTrnsRuSection";

import additionalInfo from "../../../Mobx/AdditionalInfo";

const NewInfo = observer(() => {
    const headerHeight = 104;
    const height = `calc(100vh - ${headerHeight}px)`;

    const sectionsToShow = additionalInfo.sectionsToShow || [];

    return (
        <Box
            sx={{
                height,
                overflowY: "auto",
                overflowX: "hidden",
                pt: 0.5,
                px: 0,
                pb: 0.5,
                direction: "rtl",
                bgcolor: "#f9f9f9",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
            }}
        >
            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", direction: "ltr" }}>
                {user.limitedAdmin.includes(user.email) ?
                    <Grid container spacing={0.5} justifyContent="center" sx={{ width: "100%" }}>
                        {sectionsToShow.includes("images") && <ImageSection />}
                        {/* {sectionsToShow.includes("sentences") && <SentenceSection />}
                        {sectionsToShow.includes("definitions") && <DefinitionSection />}
                        {sectionsToShow.includes("stories") && <StorySection />} */}
                        {/* {sectionsToShow.includes("trnsAr") && <NewTrnsArSection />} */}
                        {/* {sectionsToShow.includes("trnsRu") && <NewTrnsRuSection />} */}
                        {sectionsToShow.includes("distractingForTrns") && <DistractingForTrnsSection />}
                        {sectionsToShow.includes("distractingForOriginal") && <DistractingForOriginalSection />}
                        {/* {sectionsToShow.includes("distractingForDefinitionInEng") && <DistractingForDefinitionInEngSection />}
                        {sectionsToShow.includes("distractingForDefinitionInHeb") && <DistractingForDefinitionInHebSection />}
                        {sectionsToShow.includes("distractingForWordFamilies") && <DistractingForWordFamiliesSection />}
                        {sectionsToShow.includes("sentencesWithMissing") && <SentencesWithMissingSection />}
                        {sectionsToShow.includes("sentencesWithLastMissing") && <SentencesWithLastMissingSection />}
                        {sectionsToShow.includes("opposites") && <OppositesSection />}
                        {sectionsToShow.includes("synonyms") && <SynonymsSection />} */}
                    </Grid>
                    :
                    <Grid container spacing={0.5} justifyContent="center" sx={{ width: "100%" }}>
                        {sectionsToShow.includes("images") && <ImageSection />}
                        {sectionsToShow.includes("sentences") && <SentenceSection />}
                        {sectionsToShow.includes("definitions") && <DefinitionSection />}
                        {sectionsToShow.includes("stories") && <StorySection />}
                        {sectionsToShow.includes("trnsAr") && <NewTrnsArSection />}
                        {sectionsToShow.includes("trnsRu") && <NewTrnsRuSection />}
                        {sectionsToShow.includes("distractingForTrns") && <DistractingForTrnsSection />}
                        {sectionsToShow.includes("distractingForOriginal") && <DistractingForOriginalSection />}
                        {sectionsToShow.includes("distractingForDefinitionInEng") && <DistractingForDefinitionInEngSection />}
                        {sectionsToShow.includes("distractingForDefinitionInHeb") && <DistractingForDefinitionInHebSection />}
                        {sectionsToShow.includes("distractingForWordFamilies") && <DistractingForWordFamiliesSection />}
                        {sectionsToShow.includes("sentencesWithMissing") && <SentencesWithMissingSection />}
                        {sectionsToShow.includes("sentencesWithLastMissing") && <SentencesWithLastMissingSection />}
                        {sectionsToShow.includes("opposites") && <OppositesSection />}
                        {sectionsToShow.includes("synonyms") && <SynonymsSection />}
                    </Grid>
                }
            </Box>
        </Box>
    );
});

export default NewInfo;
